import React, {useState} from 'react';
import './CSS/About.css';

import linkdenlogo from "../../Assets/Images/In-Blue-48@2x.png";


import coryPhoto from '../../Assets/Images/People/Cory-Lausch-500x500_Circle-White-background.png';
import joelPhoto from '../../Assets/Images/People/Joel_500x500_Circle-White-background.png';
import haileyPhoto from '../../Assets/Images/People/Hailey-500x500_Circle-White-background.png';
import michaelPhoto from '../../Assets/Images/People/MB277.jpg';
import {Link} from "react-router-dom";

const testimonials = [
    {
        id: 1,
        name: "Michael Bach",
        position: "CEO",
        company: "Michael Bach Consulting",
        photo: michaelPhoto,
        testimonial: "VIZEdi is a fantastic tool for employers that want to create inclusive cultures in that it challenges people's perceptions of how inclusive their communications are, and helps them correct them"
    }
];

const AboutUs: React.FC = () => {
    const [showMoreHailey, setShowMoreHailey] = useState(false);
    const [showMoreCory, setShowMoreCory] = useState(false);
    const [showMoreJoel, setShowMoreJoel] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);


    const toggleCoryText = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        setShowMoreCory((prev) => !prev);
    };

    const toggleHaileyText = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        setShowMoreHailey((prev) => !prev);
    };

    const toggleJoelText = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        setShowMoreJoel((prev) => !prev);
    };

    return (
        <div>
            <section className="about-header">
                <h1>Committed to a World Where Everyone Belongs</h1>
            </section>

            <section className="story-section">
                <h2>The VIZE Story</h2>
                <p>At VIZEdi, we believe that communication is the key to fostering a workplace where everyone feels
                    they belong. Founded in 2020, our mission is to help organizations create inclusive environments
                    through everyday communication.</p>
            </section>

            <section className="our-mission">
                <h2>Our Mission</h2>
                <p>We’re on a mission to empower businesses to communicate inclusively, helping to eliminate bias and
                    promote belonging across the board.</p>
            </section>

            <section className="people-section">
                <h2>Our People</h2>
                <div className="person-card">
                    <img className="photo" src={haileyPhoto} alt="Hailey Schwabe"/>
                    <h3>Hailey Schwabe (she/her)</h3>
                    <p>Co-Founder, COO</p>
                    <div className="linkedin-container">
                        <a href="https://www.linkedin.com/in/hailey-schwabe-58485b44/" target="_blank"
                           rel="noopener noreferrer">
                            <img className="linkedin-icon" src={linkdenlogo} alt="LinkedIn"/>
                        </a>
                    </div>
                    <hr/>
                    <a href="#more-about-hailey" onClick={toggleHaileyText}>
                        More about Hailey
                    </a>
                    <p className={`more-about-text ${showMoreHailey ? 'expanded' : ''}`}>
                        Hailey is a seasoned entrepreneur with a decade of experience in building customer
                        service-focused B2B companies. As COO and Co-founder of Vize Labs Inc., Hailey’s passion lies in
                        leveraging technology to foster diversity, inclusion, and a sense of belonging in the workplace.
                        She firmly believes that businesses benefit greatly from diverse lived experiences, and that
                        creating a supportive and nurturing work environment is key to unlocking people’s full
                        potential. Hailey is also a proud parent and partner who enjoys experimenting with new recipes
                        in her free time. She welcomes any challenge that allows her to unleash her creativity and
                        tackle problems with a fresh perspective.
                    </p>
                </div>
                <div className="person-card">
                    <img className="photo" src={joelPhoto} alt="Joel Pinel"/>
                    <h3>Joel Pinel (he/him)</h3>
                    <p>Co-Founder, CEO</p>
                    <div className="linkedin-container">
                        <a href="https://www.linkedin.com/in/joel-pinel-22117143/" target="_blank"
                           rel="noopener noreferrer">
                            <img className="linkedin-icon" src={linkdenlogo} alt="LinkedIn"/>
                        </a>
                    </div>
                    <hr/>
                    <a href="#more-about-joel" onClick={toggleJoelText}>
                        More about Joel
                    </a>
                    <p className={`more-about-text ${showMoreJoel ? 'expanded' : ''}`}>
                        Joel, named Canada’s Top Young Entrepreneur in 2013, is a visionary leader who values people
                        above all else. Through his several successful business ventures, he has demonstrated a
                        commitment to fostering a culture of high-functioning, purposeful achievement, and happiness. As
                        the CEO and Co-founder of Vizelabs, Joel’s focus is on building up everyone around him, enabling
                        them to thrive and advance. He is deeply committed to his family and has a passion for all types
                        of food and enjoys savoring a good scotch. In addition, Joel is a big sports fan, and you can
                        often find him cheering for his favorite teams during his free time.
                    </p>
                </div>
                <div className="person-card">
                    <img className="photo" src={coryPhoto} alt="Cory Lausch"/>
                    <h3>Cory Lausch (he/him)</h3>
                    <p>CTO</p>
                    <div className="linkedin-container">
                        <a href="https://www.linkedin.com/in/corylausch/" target="_blank" rel="noopener noreferrer">
                            <img className="linkedin-icon" src={linkdenlogo} alt="LinkedIn"/>
                        </a>
                    </div>
                    <hr/>
                    <a href="#more-about-cory" onClick={toggleCoryText}>
                        More about Cory
                    </a>
                    <p className={`more-about-text ${showMoreCory ? 'expanded' : ''}`}>
                        Cory is a driven and passionate CTO who has had a love for technology from a young age and has
                        dedicated his career to mastering the field, with a particular focus on AI and machine learning.
                        He has a deep understanding of the technology landscape, and stays on top of the latest trends
                        and innovations. As a new parent, Cory loves spending time with his family and watching them
                        grow. Beyond technology, Cory has a keen interest in the science behind flavor in cooking and is
                        an excellent cook himself. When he’s not working on technology, you’ll likely find him solving
                        problems and exploring new areas of tech to further his knowledge and expertise. With his
                        boundless curiosity and drive to learn, Cory is always looking for ways to make an impact in the
                        tech world and beyond.
                    </p>
                </div>
            </section>

            <section className="testimonial-section">
                <div className="testimonial-card">
                    <div className="testimonial-left">
                        <img
                            className="testimonial-photo"
                            src={testimonials[currentIndex].photo}
                            alt={testimonials[currentIndex].name}
                        />
                    </div>
                    <div className="testimonial-right">
                        <div className="testimonial-info">
                            <h3>{testimonials[currentIndex].name} - {testimonials[currentIndex].position}</h3>
                            <p>{testimonials[currentIndex].company}</p>
                        </div>
                        <div className="testimonial-body">
                            <p>{testimonials[currentIndex].testimonial}</p>
                        </div>
                    </div>
                </div>

                {/*<div className="testimonial-navigation">*/}
                {/*    <button className="arrow-button" onClick={prevTestimonial}>&#8592;</button>*/}
                {/*    <button className="arrow-button" onClick={nextTestimonial}>&#8594;</button>*/}
                {/*</div>*/}
            </section>

            <section>
                <div className="cta-section">
                    <h2 className="cta-title">Ready to Build Belonging?</h2>
                    <p className="cta-description">
                        Deeper Insights for building lasting belonging in the workplace
                    </p>
                    <Link to="/login">
                        <button className="cta-button">Start Now</button>
                    </Link>
                </div>
            </section>

        </div>
    );
};

export default AboutUs;
